function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:transparent;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_179",
  "data-name": "Group 179",
  transform: "translate(.75 .75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_461",
  "data-name": "Path 461",
  className: "cls-1",
  d: "M12.746 11.876v1.184m-6.712-1.184v3.551m3.356-3.551V14.1M4.356 3h10.068a3.457 3.457 0 0 1 3.356 3.551v8.876a3.457 3.457 0 0 1-3.356 3.551H4.356A3.457 3.457 0 0 1 1 15.427V6.551A3.457 3.457 0 0 1 4.356 3z",
  transform: "translate(-1 -1)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_462",
  "data-name": "Path 462",
  className: "cls-1",
  d: "M7 1v4",
  transform: "translate(-1.966 -1)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_463",
  "data-name": "Path 463",
  className: "cls-1",
  d: "M15 1v4",
  transform: "translate(-3.254 -1)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_464",
  "data-name": "Path 464",
  className: "cls-1",
  d: "M1 9h16.78",
  transform: "translate(-1 -1.809)"
}));

var SvgDate = function SvgDate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.28,
    height: 19.478,
    viewBox: "0 0 18.28 19.478",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/date.33b32724.svg";
export { ForwardRef as ReactComponent };